// extracted by mini-css-extract-plugin
module.exports = {"scrollee":"Scrollee_scrollee","scrolleeShifted":"Scrollee_scrolleeShifted"};